import React from "react";

type PageTransitionProps = {
  children: React.ReactNode;
  classNames?: string;
  timeout?: number;
};

// Lightweight stand-in for next-page-transitions to avoid React peer conflicts.
export const PageTransition: React.FC<PageTransitionProps> = ({ children }) => (
  <>{children}</>
);

export default PageTransition;
